import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import RightPanel from '@/components/RightPanel';
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import { mapState } from 'vuex';
import Theme from '@/components/ThemePicker';
import Cookies from 'js-cookie';
import store from '@/store';
import { getClock } from '@/api/admissionCounseling/myCustomers';
import call from './components/phoneCall';
export default {
  name: 'Layout',
  components: {
    AppMain: AppMain,
    Navbar: Navbar,
    RightPanel: RightPanel,
    Settings: Settings,
    Sidebar: Sidebar,
    TagsView: TagsView,
    Theme: Theme
  },
  mixins: [ResizeMixin],
  data: function data() {
    return {
      clock: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    },
    showSettings: function showSettings(state) {
      return state.settings.showSettings;
    },
    needTagsView: function needTagsView(state) {
      return state.settings.tagsView;
    },
    fixedHeader: function fixedHeader(state) {
      return state.settings.fixedHeader;
    },
    isCall: function isCall(state) {
      return state.user.call.cId;
    }
  })), {}, {
    classObj: function classObj() {
      var sidebar = this.sidebar,
        device = this.device,
        isCall = this.isCall;
      return {
        hideSidebar: !sidebar.opened,
        openSidebar: sidebar.opened,
        withoutAnimation: sidebar.withoutAnimation,
        mobile: device === 'mobile',
        isCall: isCall
      };
    }
  }),
  watch: {
    'isCall': function isCall(newVal) {
      if (newVal) {
        call(this);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (Cookies.get('theme')) {
      this.$refs.theme.theme = Cookies.get('theme');
      this.$store.dispatch('settings/changeSetting', {
        key: 'theme',
        value: Cookies.get('theme')
      });
    }
    var _store$state$user = store.state.user,
      clocks = _store$state$user.clocks,
      user = _store$state$user.user;

    // this.$welcomeBack({
    //   msg: '您已有XX分钟没有操作系统了，系统在XX:XX:XX已将你置为离线状态。收到本消息代表您已被唤醒，唤醒后将重新加入分配引擎。',
    // });
    var _loop = function _loop(i) {
      // 判断闹钟状态
      _this.clock = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getClock({
                cId: clocks[i].customerId,
                id: user.id
              });
            case 1:
              res = _context.v;
              if (res.status) {
                _this.$alarm({
                  timerId: _this.clock,
                  id: clocks[i].id,
                  name: clocks[i].name,
                  contactPhone: res.customerSmallDto.contactPhone,
                  contactWechat: res.customerSmallDto.contactWechat,
                  customerId: clocks[i].customerId
                });
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      })), clocks[i].time);
    };
    for (var i = 0; i < clocks.length; i++) {
      _loop(i);
    }
  },
  destroyed: function destroyed() {
    var clock = this.clock;
    clearTimeout(clock);
  },
  methods: {
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    }
  }
};